import React, { useEffect, useState } from 'react'
import { getMyProfile } from '../../../helpers'
import { PrincipalLayouts } from '../../../layouts/PrincipalLayouts'
import { MyProfile } from '../../views/MyProfile'

export const GetUser = () => {

    const [user, setUser] = useState('isLoading')

    useEffect(() => {
        const getProfile = async() => {
            const user = await getMyProfile()
            setUser(user)
        }
        getProfile()
    }, [])

    return (
        <PrincipalLayouts>
            {
                (user !== 'isLoading' && user.ok) &&
                <MyProfile user={user.data} />
            }
        </PrincipalLayouts>
    )
}
